<template>
    <v-container class="d-flex justify-center align-center pa-0 fill-height">
    <v-icon v-if="originalValue == null" color="primary" :icon="icon" class="cursor-pointer"/>
            <span v-else>{{ originalValue }}</span>
    </v-container>
</template>
<script setup>
    import { onBeforeMount, ref } from 'vue';
    import {mdiTrashCanOutline} from '@mdi/js'

    const props = defineProps(['params']);

    const icon = ref(null);
    const originalValue = ref(null);
    onBeforeMount(() => {
        if (!props.params.node.group && props.params.colDef.field == "delete" && props.params.node.rowPinned != "bottom") {
            let forbbidenAttributes = [
                "format",
                "specificites".replace(/[\u0300-\u036f]/g, ""),
                "contenance",
            ];
            if ( typeof props.params.node.data != "undefined" && typeof props.params.node.data.userName != "undefined" 
                        && forbbidenAttributes.indexOf(props.params.node.data.userName
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "")
                        .toLowerCase(),
                        ) == -1){
                icon.value = mdiTrashCanOutline;
                }
        }

        // ROW PINNED BOTTOM
        else originalValue.value = "";
    })

</script>
